export default __webpack_public_path__ + "static/media/excel.c1be05ff.svg";